/* eslint-disable no-unused-vars */
import React from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";

import "./Works.css";

import Miricanvas from "../../assets/recentprojects/miricanvas.png";
import VirtualRun from "../../assets/recentprojects/42race.png";
import DearMate from "../../assets/recentprojects/dearmate.png";
import Myda from "../../assets/recentprojects/myda.png";
import OpenHouse from "../../assets/recentprojects/openhouse.png";
import Pickspix from "../../assets/recentprojects/pickspix.png";

const useStyles = makeStyles(() => ({
  main: {
    maxWidth: "100vw",
    marginTop: "3em",
    marginBottom: "auto",
  },
}));

export const Works = () => {
  const classes = useStyles();

  const projects = [
    {
      id: 0,
      title: "Pickspix AI Smart Photo Curation",
      description: ` Pickspix starts from choosing your favorite  photos, which seems easy and simple, but it is a difficult task to create an experience that has never been in the world.`,
      alter: "Pickspix",
      image: `${Pickspix}`,
    },
    {
      id: 1,
      title: "Miricanvas Design Tool System",
      description: ` Miri Canvas is the site that most Korean people use as a tool to help them create simple yet eye-catching graphics, slides, and images.`,
      alter: "Miricanvas",
      image: `${Miricanvas}`,
    },
    {
      id: 2,
      title: "42Race Virtual Fitness Platform",
      description: `A virtual race/ virtual fitness challenge is an online gamified experience to bring participants together via an interactive journey to
      keep fit and achieve a common goal.`,
      alter: "VirtualRun",
      image: `${VirtualRun}`,
    },
    {
      id: 3,
      title: "DearMate AI",
      description: `You can enjoy fun chatting with AI mates of various characters`,
      alter: "DearMate",
      image: `${DearMate}`,
    },
    {
      id: 4,
      title: "Myda Cloud Business",
      description: `Automate your business processes, order fulfilment and more, gain access to predictive intelligence on the go to run an efficient and smarter business - increasing your sales & profit.`,
      alter: "Myda",
      image: `${Myda}`,
    },
    {
      id: 5,
      title: "Open House Architecture",
      description: `Open House Development, which is in charge of development and construction, and Open House Architect, who is in charge of construction, are working together to create a "life-size" house.`,
      alter: "OpenHouse",
      image: `${OpenHouse}`,
    },
  ];

  return (
    <section id="works">
      <Container component="main" className={classes.main} maxWidth="md">
        {projects.map((project) => (
          <div className="project" key={project.id}>
            <div className="__img_wrapper">
              <img src={project.image} alt={project.alter} className="image" />
            </div>
            <div className="__content_wrapper">
              <h3 className="title">
                <TextDecrypt text={project.title} />
              </h3>
              <p className="description">{project.description}</p>
            </div>
          </div>
        ))}
      </Container>
    </section>
  );
};
